// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.afCKdhJ_CSOJa2 {
  position: relative;
  width: 321px;
  margin-bottom: var(--ds-space-200, 16px);
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-radius-small, 3px);
  text-align: center;
}
.afCKdhJ_CSOJa2 .aJikksDdI0OK7w {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-250, 18px);
  margin-bottom: var(--ds-space-0, 0);
}
.afCKdhJ_CSOJa2 .zdXUUWpcT6nmRx {
  font-weight: var(--ds-font-weight-regular, 400);
  margin-top: var(--ds-space-100, 8px);
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
}
.afCKdhJ_CSOJa2 .lgYLCHLbdETtqd {
  font-weight: var(--ds-font-weight-regular, 400);
  display: flex;
  align-items: center;
  margin-top: var(--ds-space-200, 16px);
  margin-bottom: var(--ds-space-0, 0px);
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  text-align: center;
}
.afCKdhJ_CSOJa2 .lgYLCHLbdETtqd strong {
  width: 100%;
}
.afCKdhJ_CSOJa2 .jbBp9KurxycGI9 {
  font-weight: var(--ds-font-weight-regular, 400);
  margin-bottom: var(--ds-space-200, 16px);
  font-size: 12px;
  line-height: 16px;
}
.afCKdhJ_CSOJa2 .OuJ5FZf6GyZUHW {
  margin-bottom: var(--ds-space-200, 16px);
}
.afCKdhJ_CSOJa2 .OuJ5FZf6GyZUHW .yf4n6WYKi03R7A {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
.afCKdhJ_CSOJa2 .OuJ5FZf6GyZUHW .igoDvzLCwNvNh4,
.afCKdhJ_CSOJa2 .OuJ5FZf6GyZUHW .YW3Lmw51pr8sPI {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  margin-left: var(--ds-space-075, 5px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.afCKdhJ_CSOJa2 ._h308fl1FdA46c {
  margin-bottom: var(--ds-space-200, 16px);
}
.afCKdhJ_CSOJa2 ._h308fl1FdA46c .nqWQIK1QrOHeo9 {
  font-weight: var(--ds-font-weight-regular, 400);
  display: inline-block;
  margin-left: var(--ds-space-075, 5px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.afCKdhJ_CSOJa2 .uqMu8hkfn1fY7z {
  display: grid;
  height: 70px;
  padding: var(--ds-space-0, 0) var(--ds-space-200, 15px);
  border: 1px solid var(--ds-border, #091e4224);
  background: var(--ds-background-neutral, #091e420f);
  place-items: center;
}
.afCKdhJ_CSOJa2 .uqMu8hkfn1fY7z p {
  margin-bottom: var(--ds-space-0, 0);
}
@media only screen and (max-width: 450px) {
  .afCKdhJ_CSOJa2 {
    width: 265px;
  }
}
`, ""]);
// Exports
export var planCard = `afCKdhJ_CSOJa2`;
export var name = `aJikksDdI0OK7w`;
export var info = `zdXUUWpcT6nmRx`;
export var infoHeading = `lgYLCHLbdETtqd`;
export var infoBody = `jbBp9KurxycGI9`;
export var priceContainer = `OuJ5FZf6GyZUHW`;
export var price = `yf4n6WYKi03R7A`;
export var frequency = `igoDvzLCwNvNh4`;
export var pricingVaries = `YW3Lmw51pr8sPI`;
export var ctaContainer = `_h308fl1FdA46c`;
export var currentPlan = `nqWQIK1QrOHeo9`;
export var enterpriseFooter = `uqMu8hkfn1fY7z`;
export default ___CSS_LOADER_EXPORT___;
